document.addEventListener("DOMContentLoaded", () => {
  const heroes = document.querySelectorAll(".hero-block");

  heroes.forEach(hero => {
    console.log("Hero block inicializado:", hero);
  });
});
